import { render, staticRenderFns } from "./SystemStat.vue?vue&type=template&id=60c58451&scoped=true&"
import script from "./SystemStat.vue?vue&type=script&lang=js&"
export * from "./SystemStat.vue?vue&type=script&lang=js&"
import style0 from "./SystemStat.vue?vue&type=style&index=0&id=60c58451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c58451",
  null
  
)

export default component.exports